module.exports = __webpack_public_path__ + "static/media/azure-administrator-associate.bc6fc4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/azure-administrator-associate.png
// module id = 1372
// module chunks = 0